<template>
  <div v-if="(clientData && plan) || (distributorData && plan)">
    <router-view :key="$router.fullPath"></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { GLOBAL_ROLES } from '../assets/constants';

export default {
  name: 'ClientAccountPage',
  computed: {
    ...mapState({
      clientData: (state) => state.clients.clientData,
      plan: (state) => state.subscriptions.planData,
      distributorData: (state) => state.distributors.distributorData,
      userData: (state) => state.profile.profileData
    })
  },
  async created() {
    if (this.userData && this.userData.role === 'creator') {
      this.$router.push({ name: 'profile' });
    }
    await this.loadViewData();
  },
  methods: {
    async loadViewData() {
      if (this.userData) {
        if (this.userData.distributorId && GLOBAL_ROLES[this.userData.role]) {
          await this.$store.dispatch('getDistributorDate');
        } else if (this.userData.selectedClientId) {
          await this.$store.dispatch('getClientData');
          await this.$store.dispatch('getCatalogueData');
        }
      }
    }
  }
};
</script>
